(() => {
  function initToc() {
    const root = document.querySelector(".raitooe-compliance-hero");
    if (!root || root.dataset.tocReady === "true") return;

    const fab = root.querySelector(".toc-fab");
    const toc = root.querySelector(".toc");
    const list = root.querySelector("[data-compliance-toc-list]");
    const closeButton = root.querySelector(".toc-close");
    const backdrop = root.querySelector(".toc-backdrop");
    const currentBadge = root.querySelector(".toc-fab-current");
    const sections = [...document.querySelectorAll("[data-compliance-toc]")];

    if (!fab || !toc || !list || !closeButton || !backdrop || !currentBadge || !sections.length) return;

    root.dataset.tocReady = "true";
    list.replaceChildren(
      ...sections.map((section) => {
        const item = document.createElement("li");
        const link = document.createElement("a");
        const number = document.createElement("span");
        number.textContent = section.dataset.complianceNumber || "";
        link.href = `#${section.id}`;
        link.append(number, document.createTextNode(section.dataset.complianceLabel || ""));
        item.append(link);
        return item;
      }),
    );

    const links = [...list.querySelectorAll('a[href^="#"]')];
    let frame = 0;

    function setOpen(open) {
      document.body.classList.toggle("raitooe-compliance-toc-open", open);
      fab.setAttribute("aria-expanded", String(open));
      toc.setAttribute("aria-hidden", String(!open));
      if (open) closeButton.focus();
      else if (toc.contains(document.activeElement)) fab.focus();
    }

    function update() {
      frame = 0;
      fab.classList.toggle("is-visible", sections[0].getBoundingClientRect().top < window.innerHeight * 0.82);
      const readingLine = window.innerHeight * 0.32;
      let activeSection = sections[0];
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= readingLine) activeSection = section;
      });

      links.forEach((link) => {
        const active = link.getAttribute("href") === `#${activeSection.id}`;
        link.classList.toggle("is-active", active);
        if (active) {
          link.setAttribute("aria-current", "location");
          currentBadge.textContent = link.querySelector("span")?.textContent.trim() || "01";
        } else {
          link.removeAttribute("aria-current");
        }
      });
    }

    fab.addEventListener("click", () => setOpen(!document.body.classList.contains("raitooe-compliance-toc-open")));
    closeButton.addEventListener("click", () => setOpen(false));
    backdrop.addEventListener("click", () => setOpen(false));
    links.forEach((link) => link.addEventListener("click", () => setOpen(false)));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && document.body.classList.contains("raitooe-compliance-toc-open")) setOpen(false);
    });
    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    window.addEventListener("scroll", requestUpdate, { passive: true });
    document.addEventListener("scroll", requestUpdate, { passive: true, capture: true });
    window.addEventListener("resize", update);
    update();
  }

  function initCheckers() {
    document.querySelectorAll(".raitooe-compliance .checker").forEach((checker) => {
      if (checker.dataset.checkerReady === "true") return;

      const rows = [...checker.querySelectorAll(".check-row")];
      const inputs = [...checker.querySelectorAll('input[type="radio"]')];
      const result = checker.querySelector(".check-result");
      const resultCount = checker.querySelector(".result-count");
      const resultTitle = checker.querySelector(".check-result h3");
      const resultText = checker.querySelector(".result-text");
      const progress = checker.querySelector(".checker-progress");
      const progressBar = checker.querySelector(".checker-progress span");
      const resetButton = checker.querySelector(".check-result button");
      const total = rows.length;

      if (!result || !resultCount || !resultTitle || !resultText || !progress || !progressBar || !resetButton || !total) return;
      checker.dataset.checkerReady = "true";

      const copy = {
        danger: { title: checker.dataset.dangerTitle, text: checker.dataset.dangerText },
        caution: { title: checker.dataset.cautionTitle, text: checker.dataset.cautionText },
        safe: { title: checker.dataset.safeTitle, text: checker.dataset.safeText },
      };

      function update() {
        const checked = rows.map((row) => row.querySelector('input[type="radio"]:checked'));
        const answered = checked.filter((input) => input && input.value !== "unknown").length;
        const criticalRows = rows.filter((row) => row.dataset.critical === "true");
        const criticalNo = criticalRows.some((row) => row.querySelector('input[value="no"]:checked'));
        const criticalUnknown = criticalRows.some((row) => {
          const input = row.querySelector('input[type="radio"]:checked');
          return !input || input.value === "unknown";
        });
        const anyNo = checked.some((input) => input?.value === "no");
        const complete = checked.every((input) => input && input.value !== "unknown");
        const tone = criticalNo ? "danger" : criticalUnknown || anyNo || !complete ? "caution" : "safe";

        inputs.forEach((input) => input.closest("label")?.classList.toggle("selected", input.checked));
        result.classList.remove("result-danger", "result-caution", "result-safe");
        result.classList.add(`result-${tone}`);
        resultCount.innerHTML = `${answered}<small> / ${total}</small>`;
        resultTitle.textContent = copy[tone].title;
        resultText.textContent = copy[tone].text;
        progressBar.style.width = `${(answered / total) * 100}%`;
        progress.setAttribute("aria-label", `${total}問中${answered}問回答`);
      }

      inputs.forEach((input) => input.addEventListener("change", update));
      resetButton.addEventListener("click", () => {
        inputs.forEach((input) => { input.checked = false; });
        update();
      });
      update();
    });
  }

  function init() {
    initToc();
    initCheckers();
  }

  init();
  document.addEventListener("shopify:section:load", init);
})();
